import React from 'react';

import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import {
    faInfoCircle,
    faExclamationCircle,
    faChevronRight,
    faPlusCircle
} from '@fortawesome/free-solid-svg-icons';



export const infoCircle = (size: FontAwesomeIconProps['size'], color: string) => (<FontAwesomeIcon
    data-testid="fa-info-circle-icon"
    size={size}
    color={color}
    icon={faInfoCircle}
/>);

export const exclamationCircle = (<FontAwesomeIcon
    data-testid="fa-exclamation-circle-icon"
    size="sm"
    icon={faExclamationCircle}
/>);

export function rightChevron(size: FontAwesomeIconProps['size'], color: string) {
    return (<FontAwesomeIcon
        data-testid="fa-exclamation-circle-icon"
        size={size}
        color={color}
        icon={faChevronRight}
    />);
}

export function plusCircle(size: FontAwesomeIconProps['size'], color: string) {
    return (<FontAwesomeIcon
        data-testid="fa-exclamation-circle-icon"
        size={size}        
        color={color}
        icon={faPlusCircle}
    />);
}
